"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  isPpaLabel: true,
  PpaLabel: true
};
Object.defineProperty(exports, "PpaLabel", {
  enumerable: true,
  get: function () {
    return _PpaLabel.PpaLabel;
  }
});
Object.defineProperty(exports, "isPpaLabel", {
  enumerable: true,
  get: function () {
    return _isPpaLabel.isPpaLabel;
  }
});
var _isPpaLabel = require("./isPpaLabel");
var _PpaLabel = require("./PpaLabel");
var _getPpaLabelFromGql = require("./getPpaLabelFromGql");
Object.keys(_getPpaLabelFromGql).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _getPpaLabelFromGql[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getPpaLabelFromGql[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
